import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { SectionHeader, LoadingOverlay } from "../../components/common/primitives";
import { C } from "../../theme/tokens";
import { useCourses } from "../../hooks/useCourses";
import { CourseListCard } from "./CourseListCard";
import { CourseDetailScreen } from "./CourseDetailScreen";

export function EducationScreen({ t, lang, wide, user, authFetch }) {
  const { status, courses, reload } = useCourses(authFetch, t);
  const [openId, setOpenId] = useState(null);
  const openCourse = courses.find((c) => c.id === openId);

  if (openCourse) {
    return (
      <CourseDetailScreen
        course={openCourse}
        t={t}
        onBack={() => setOpenId(null)}
        wide={wide}
        user={user}
        authFetch={authFetch}
      />
    );
  }

  return (
    <div>
      <SectionHeader eyebrow="Course path" title={t.edu_title} sub={t.edu_sub} wide={wide} />

      <LoadingOverlay
        active={status === "loading"}
        label={t.edu_loading}
        style={{ minHeight: status === "loading" ? (wide ? 240 : 200) : undefined }}
      >
      {status === "error" && (
        <div
          style={{
            margin: wide ? "4px 0 20px" : "4px 20px 20px",
            padding: 18,
            borderRadius: 16,
            border: `1px solid ${C.hairline}`,
            background: C.panel1,
            color: C.secondary,
            fontSize: 13.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
          }}
        >
          <span>{t.edu_error}</span>
          <button
            onClick={reload}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              background: C.panel2,
              border: `1px solid ${C.hairline}`,
              borderRadius: 10,
              padding: "8px 12px",
              color: C.primary,
              fontSize: 12.5,
              fontWeight: 600,
              cursor: "pointer",
              flexShrink: 0,
            }}
          >
            <RefreshCw size={13} /> {t.edu_retry}
          </button>
        </div>
      )}

      {status === "ready" && courses.length === 0 && (
        <div
          style={{
            padding: wide ? "20px 0" : "20px 20px",
            color: C.secondary,
            fontSize: 13.5,
          }}
        >
          {t.edu_empty}
        </div>
      )}

      {status === "ready" && courses.length > 0 && (
        <div
          style={{
            padding: wide ? "4px 0 20px" : "4px 20px 20px",
            display: "grid",
            // auto-fill lets the grid pick 1/2/3 columns purely from the
            // available width, so it adapts to any viewport without a
            // JS breakpoint of its own.
            gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
            gap: 14,
          }}
        >
          {courses.map((c) => (
            <CourseListCard key={c.id} course={c} t={t} onOpen={() => setOpenId(c.id)} />
          ))}
        </div>
      )}
      </LoadingOverlay>
    </div>
  );
}
